export const BREAKFAST = { id: 1, name: 'Breakfast' }
export const LUNCH = { id: 2, name: 'Lunch' }
export const DINNER = { id: 3, name: 'Dinner' }
export const SNACK = { id: 4, name: 'Snack' }

export const MEALS = [BREAKFAST, LUNCH, SNACK, DINNER]
